import { v1ApiClient } from '@/services';
import type { ResponseBody } from '@/shared/api/generated';

type ScraperHealthPath = '/v1/scrapers/health';

export const getScraperHealth = () =>
  v1ApiClient.get<ResponseBody<ScraperHealthPath, 'get'>>('/scrapers/health');
